<template>
  <div class="mk-size-input">
    <div class="mk-size-input__container">
      <div
        class="mk-size-input__label"
      >
        {{label}}
      </div>
      <div class="mk-size-input__inputs">
        <input
          type="number"
          step="0.01"
          class="mk-size-input__inputs__value"
          v-model="valueInMetric"
          @focus="onFocus"
          @blur="isFocused = false"
        />
        <span
          class="mk-size-input__inputs__metric"
        >
          {{isImperial ? 'inch' : 'mm'}}
        </span>
      </div>
    </div>
    <div class="mk-size-input__min-max" v-if="isFocused">
      <span>min: {{inMetric(minValue)}}{{isImperial ? '"' : 'mm'}}</span>
      <span>max: {{inMetric(maxValue)}}{{isImperial ? '"' : 'mm'}}</span>
    </div>
  </div>
</template>

<script>
/**
 * Size INPUT
 * @author David <david.prenninger@gmx.de>
 *
 * General Input component. It shows the value in mm or inch
 * and processes the input value on change.
 */
export default {
  props: {
    label: String,
    open: Boolean,
    focusCallback: Function,
    updateValue: Function,
    value: Number,
    maxValue: undefined || Number,
    minValue: undefined || Number,
    isImperial: Boolean,
  },
  data() {
    return {
      inputTimeout: undefined,
      isFocused: false,
    };
  },
  computed: {
    valueInMetric: {
      get() {
        if (!this.isImperial) {
          return Math.floor(this.value * 500);
        }
        return Number(((this.value * 500) / 25.4).toFixed(1));
      },
      set(value) {
        if (this.inputTimeout) {
          clearTimeout(this.inputTimeout);
        }
        this.inputTimeout = setTimeout(() => {
          console.log(value);
          if (value !== '') {
            console.log(value);
            if (!this.isImperial) {
              if (value > this.maxValue) {
                this.updateValue(this.maxValue / 500);
                this.value = (this.maxValue / 500);
                return;
              }
              if (value < this.minValue) {
                this.updateValue(this.minValue / 500);
                this.value = (this.maxValue / 500);
                return;
              }
              this.updateValue(value / 500);
              this.value = (value / 500);
              return;
            }
            if (value * 25.4 > this.maxValue) {
              this.updateValue(this.maxValue / 500);
              this.value = ((this.maxValue / 500) * 25.4);
              return;
            }
            if (value * 25.4 < this.minValue) {
              this.updateValue(this.minValue / 500);
              this.value = ((this.minValue / 500) * 25.4);
              return;
            }
            this.updateValue((value * 25.4) / 500);
            this.value = ((value * 25.4) / 500);
          }
        }, 1000);
      },
    },
  },
  methods: {
    onFocus() {
      this.isFocused = true;
      this.focusCallback();
    },
    inMetric(value) {
      if (!this.isImperial) {
        return Math.floor(value);
      }
      return Number((value / 25.4).toFixed(1));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-size-input {
  border: 1px solid $c_primary_light;
  margin: 10px 0;
  display: flex;
  min-height: 32px;
  flex-direction: column;
  border-radius: $br_md;
  overflow: hidden;

  &__container {
    display: flex;
    align-items: center;
  }

  &__min-max {
    display: flex;
    justify-content: space-between;
    background-color: $c_primary_light;
    padding: 5px 15px;
    font-size: 14px;
  }

  &__label {
    box-sizing: border-box;
    flex: 0 0 140px;
    height: 100%;
    background-color: $c_accent;
    color: $c_white;
    padding: 10px;
    font-weight: 500;
    font-size: 14px;
  }

  &__inputs {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;

    &__value {
      text-align: center;
      border: none;
      font-weight: 500;
      width: 50%;
      font-size: 14px;
    }
    &__metric {
      text-align: center;
      border: none;
    }
  }
}
</style>
